import React from "react";

const UserNotFound = () => {
  const styles = {
    body: {
      background: "#eceff1",
      color: "rgba(0, 0, 0, 0.87)",
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
      margin: 0,
      padding: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    },
    message: {
      background: "white",
      maxWidth: "360px",
      padding: "32px 24px 16px",
      borderRadius: "3px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)",
      textAlign: "center",
    },
    h2: {
      color: "#ffa100",
      fontWeight: "bold",
      fontSize: "16px",
      margin: "0 0 8px",
    },
    h1: {
      fontSize: "22px",
      fontWeight: "300",
      color: "rgba(0, 0, 0, 0.6)",
      margin: "0 0 16px",
    },
    h3: {
      color: "#888",
      fontWeight: "normal",
      fontSize: "16px",
      margin: "16px 0 12px",
    },
    p: {
      lineHeight: "140%",
      margin: "16px 0 24px",
      fontSize: "14px",
    },
    a: {
      display: "block",
      textAlign: "center",
      background: "#039be5",
      textTransform: "uppercase",
      textDecoration: "none",
      color: "white",
      padding: "7px",
      borderRadius: "4px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)",
    },
  };

  return (
    <div style={styles.body}>
      <div style={styles.message}>
        <h2 style={styles.h2}>404</h2>
        <h1 style={styles.h1}>Invalid Login</h1>
        <h3 style={styles.h3}>Why am I seeing this?</h3>
        <p style={styles.p}>
          This error occurs because the system couldn't find the user you were
          looking for or the credentials provided are incorrect.
        </p>
      </div>
    </div>
  );
};
export default UserNotFound;
